<div
  class="skeleton-loader"
  *ngIf="statusDetail == 'init' && listData == undefined"
>
  <div
    class="charging-content"
    *ngFor="let item of [0, 1, 2, 3, 4, 5, 6]"
  ></div>
</div>

<div
  *ngIf="statusDetail == 'success'"
  class="table-container table-format-rows"
>
  <table class mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="image">
      <th
        class="image-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      ></th>
      <td
        class="image-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
      >
        <div *ngIf="element.path_file != ''" class="image-container">
          <img class="image-noti" [src]="element.path_file" />
        </div>
        <div *ngIf="element.path_file == ''" class="image-container">
          <img class="image-noti" [src]="noImageUrl" />
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="noti-title">
      <th
        class="notiTitle-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="title-container alt-row-align-center">
          <p
            class="title_inside alt-inter-medium alt-color-grayscale2 alt-size-14"
          >
            {{ "NOTIFICATIONS.title-noti" | translate }}
          </p>
          <div class="order-arrows alt-column-justify-center">
            <mat-icon
              class="up-order pointer"
              svgIcon="arrow"
              (click)="sortingByTitle()"
            ></mat-icon>
            <mat-icon
              class="down-order pointer"
              svgIcon="arrow"
              (click)="sortByTitledown()"
            ></mat-icon>
          </div>
        </div>
      </th>
      <td class="name-column" mat-cell *matCellDef="let element">
        <div class="noti-title-container">
          <p
            class="noti-title alt-inter-medium alt-size-14 alt-color-grayScale2"
          >
            {{ element.notification_title }}
          </p>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="programing">
      <th
        class="programing-header alt-inter-medium alt-color-grayscale2 alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        {{ "NOTIFICATIONS.title-program" | translate }}
      </th>
      <td
        class="programing-column alt-inter-medium"
        mat-cell
        *matCellDef="let element"
      >
        <div
          *ngIf="element.programming == 'schedule'; else noProgramado"
          class="noti-programming-container alt-column-justify-center"
        >
          <div *ngIf="element.sent == false; else expired">
            <p class="noti-program-text alt-size-12">
              {{ "NOTIFICATIONS.programing" | translate }}
            </p>
            <p class="noti-date alt-size-12 alt-color-grayScale2">
              {{ element.schedule_notification.date }}
              {{ element.schedule_notification.hour }}
            </p>
          </div>
          <ng-template #expired>
            <p class="noti-program-text alt-size-12">
              {{ "NOTIFICATIONS.sended" | translate }}
            </p>
          </ng-template>
        </div>
        <ng-template #noProgramado>
          <div class="no alt-column-align-center">
            <p class="noti-program-text alt-size-12">
              {{ "NOTIFICATIONS.send-now" | translate }}
            </p>
            <p class="noti-date alt-size-12 alt-color-grayScale2">
              {{ element.created_At | date : "short" : "utc" }}
            </p>
          </div>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="target">
      <th
        class="target-header alt-inter-medium alt-color-grayscale2 alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      >
        {{ "NOTIFICATIONS.title-target" | translate }}
      </th>
      <td
        class="target-column alt-inter-medium"
        mat-cell
        *matCellDef="let element"
      >
        <div
          class="target-container alt-justify-center alt-size-10"
          [class.bussines]="element.type === 'companies'"
          [class.facilitators]="element.type === 'facilitators'"
          [class.alides]="element.type === 'allies'"
        >
          <p
            *ngIf="element.type === 'allies'"
            class="target-text alt-color-grayscale6"
          >
            {{ "USERS.organization" | translate | uppercase }}
          </p>
          <p
            *ngIf="element.type === 'facilitators'"
            class="target-text alt-color-grayscale6"
          >
            {{ "DASHBOARD.facilitators" | translate | uppercase }}
          </p>
          <p
            *ngIf="element.type === 'companies'"
            class="target-text alt-color-grayscale6"
          >
            {{ "NOTIFICATIONS.companies" | translate | uppercase }}
          </p>
          <p
            *ngIf="element.type === 'all'"
            class="target-text alt-color-grayscale6"
          >
            {{ "NOTIFICATIONS.all" | translate | uppercase }}
          </p>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th
        class="edit-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      ></th>
      <td
        class="edit-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
      >
        <div class="edit-container alt-justify-center">
          <p
            class="edit-text"
            [class]="
              enableEdit(element)
                ? 'alt-color-bran1 pointer'
                : 'alt-color-grayScale2'
            "
            (click)="goToEditNotification(element)"
          >
            {{ "FACILITATOR.edit" | translate }}
          </p>
          <!-- <p
            *ngIf="element.programming == 'now' || element.sent == true"
            class="edit-text alt-color-bran1"
          >
            --:--
          </p> -->
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th
        class="delete-header alt-inter-semibold alt-size-14"
        mat-header-cell
        *matHeaderCellDef
      ></th>
      <td
        class="delete-column alt-inter-medium alt-size-14"
        mat-cell
        *matCellDef="let element"
      >
        <div class="delete-container alt-justify-center">
          <p
            class="delete-text alt-color-system pointer"
            (click)="openDialog(element._id)"
          >
            {{ "OPORTUNITIES.delete" | translate | uppercase }}
          </p>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    (page)="handlePageEvent($event)"
    [length]="length"
    [pageSize]="itemsPerPage"
    [pageIndex]="pageIndex"
    aria-label="Select page of periodic elements"
  >
  </mat-paginator>
</div>
